<template>
	<v-footer id="sg-footer" color="#111" padless>
		<v-container class="py-10">
			<v-row>
				<v-col cols="12" md="4">
					<div class="sg-footer-title mb-3">ارتباط با ما</div>
					<v-list dense color="transparent" class="pa-0">
						<v-list-item class="px-0">
							<v-list-item-icon class="ml-2"><v-icon color="#C9A227" size="20">mdi-map-marker</v-icon></v-list-item-icon>
							<v-list-item-content><v-list-item-title class="sg-footer-text">{{ address || 'آدرس فروشگاه' }}</v-list-item-title></v-list-item-content>
						</v-list-item>
						<v-list-item class="px-0">
							<v-list-item-icon class="ml-2"><v-icon color="#C9A227" size="20">mdi-phone</v-icon></v-list-item-icon>
							<v-list-item-content><v-list-item-title class="sg-footer-text">{{ phones || '—' }}</v-list-item-title></v-list-item-content>
						</v-list-item>
						<v-list-item class="px-0">
							<v-list-item-icon class="ml-2"><v-icon color="#C9A227" size="20">mdi-cellphone</v-icon></v-list-item-icon>
							<v-list-item-content><v-list-item-title class="sg-footer-text">{{ mobile || phones || '—' }}</v-list-item-title></v-list-item-content>
						</v-list-item>
						<v-list-item class="px-0" v-if="email">
							<v-list-item-icon class="ml-2"><v-icon color="#C9A227" size="20">mdi-email</v-icon></v-list-item-icon>
							<v-list-item-content><v-list-item-title class="sg-footer-text">{{ email }}</v-list-item-title></v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>

				<v-col cols="12" md="4">
					<div class="sg-footer-title mb-3">شبکه‌های اجتماعی</div>
					<div class="d-flex flex-wrap">
						<a v-if="landingSettings.instagramLink" :href="landingSettings.instagramLink" target="_blank" class="sg-social-btn">
							<v-icon color="#C9A227">mdi-instagram</v-icon>
						</a>
						<a v-if="landingSettings.telegramLink" :href="landingSettings.telegramLink" target="_blank" class="sg-social-btn">
							<v-icon color="#C9A227">mdi-send</v-icon>
						</a>
						<a v-if="landingSettings.whatsappLink" :href="landingSettings.whatsappLink" target="_blank" class="sg-social-btn">
							<v-icon color="#C9A227">mdi-whatsapp</v-icon>
						</a>
						<a v-if="landingSettings.rubikaLink" :href="landingSettings.rubikaLink" target="_blank" class="sg-social-btn">
							<v-img src="/rubika.png" width="22" contain />
						</a>
						<a v-if="landingSettings.aparatLink" :href="landingSettings.aparatLink" target="_blank" class="sg-social-btn">
							<v-img src="/aparat.png" width="22" contain />
						</a>
					</div>
					<p class="sg-footer-text mt-4 mb-0">
						<span class="gold-text">{{ businessTitle }}</span>
						— فروشگاه آنلاین طلا و جواهر با ضمانت اصالت
					</p>
				</v-col>

				<v-col cols="12" md="4">
					<div class="sg-footer-title mb-3">مجوزها و نمادها</div>
					<div class="d-flex flex-wrap align-center">
						<a v-if="landingSettings.enamadLink" :href="landingSettings.enamadLink" target="_blank" class="sg-license">
							<img src="/enamad.jpg" alt="نماد اعتماد" />
						</a>
						<a v-if="landingSettings.etehadieLink" :href="landingSettings.etehadieLink" target="_blank" class="sg-license">
							<img src="/logonama.jpg" alt="اتحادیه" />
						</a>
						<a v-if="landingSettings.samandehiLink" :href="landingSettings.samandehiLink" target="_blank" class="sg-license">
							<img src="/samandehipng.jpg" alt="ساماندهی" />
						</a>
						<a v-if="landingSettings.anjomanSenfiLink" :href="landingSettings.anjomanSenfiLink" target="_blank" class="sg-license">
							<img src="/nezamsenfi.jpg" alt="انجمن صنفی" />
						</a>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<div class="sg-footer-bottom text-center py-4">
			کلیه حقوق این سایت متعلق به {{ businessTitle }} می‌باشد. © {{ year }}
			<div><small>طراحی و توسعه توسط: <a href="https://jetaqsaat.ir" target="_blank" class="gold-text">جت اقساط</a></small></div>
		</div>
	</v-footer>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'SafeGoldsFooter',
		computed: {
			...get('appSettings', ['landingSettings']),
			...get('siteConfig', ['fullTitle']),
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle || 'طلای سیف زاده'
			},
			address() {
				return this.landingSettings?.address
			},
			phones() {
				return this.landingSettings?.phones
			},
			mobile() {
				return this.landingSettings?.mobile || this.landingSettings?.agentOfficePhone
			},
			email() {
				return this.landingSettings?.email
			},
			year() {
				return new Date().toLocaleDateString('fa-IR').substring(0, 4)
			},
		},
	}
</script>

<style lang="scss"
	scoped>
		.sg-footer-title {
			color: #D4AF37;
			font-weight: 700;
			font-size: 1.1rem;
		}

		.sg-footer-text {
			color: #bbb !important;
			font-size: 0.85rem;
			white-space: normal;
			line-height: 1.6;
		}

		.gold-text {
			color: #C9A227;
		}

		.sg-social-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 44px;
			height: 44px;
			border-radius: 50%;
			background: rgba(201, 162, 39, 0.12);
			border: 1px solid rgba(201, 162, 39, 0.3);
			margin-left: 8px;
			margin-bottom: 8px;
			transition: all 0.3s ease;

			&:hover {
				background: rgba(201, 162, 39, 0.25);
				transform: translateY(-3px);
				box-shadow: 0 6px 16px rgba(201, 162, 39, 0.2);
			}
		}

		.sg-license img {
			max-width: 80px;
			border-radius: 12px;
			margin-left: 10px;
			margin-bottom: 10px;
			transition: transform 0.3s ease;

			&:hover {
				transform: scale(1.05);
			}
		}

		.sg-footer-bottom {
			width: 100%;
			border-top: 1px solid rgba(201, 162, 39, 0.2);
			color: #888;
			font-size: 0.8rem;
		}
	</style>
